import React, { useState, useEffect } from "react";
import { Card } from "@nextui-org/react";
import { Link, useLocation } from "react-router-dom";
import { FaAngleDown } from "react-icons/fa6";
import Logo from "../../assets/images/Logo.jpg";
import SmallLogo from "../../assets/images/smallLogo.jpg";
import navItems from "./SideNavData";

const SideNav = ({ hamClick, setHamClick }) => {
  const location = useLocation();
  const [expandedCard, setExpandedCard] = useState(null);

  // Set the expandedCard based on location.pathname
  useEffect(() => {
    navItems.forEach((section) => {
      section.items.forEach((item) => {
        if (item.subcategory) {
          // Check if the current pathname matches any of the subcategory paths
          const matchSubcategory = item.subcategory.some((sub) =>
            location.pathname.includes(sub.path)
          );
          if (matchSubcategory) {
            setExpandedCard(item.id);
          }
        }
      });
    });
  }, [location.pathname]);

  const handleCardClick = (cardId) => {
    setHamClick(false);
    setExpandedCard(expandedCard === cardId ? null : cardId);
  };

  return (
    <div
      className={`h-full z-[49] ${
        hamClick ? "w-[70px]" : "w-[250px]"
      } shadow rounded-none fixed top-0 bg-white transition-[width] duration-200`}
    >
      <div className="h-full w-full">
        <Card
          className={`${
            hamClick ? "h-[50px] mb-[5px] mt-[5px]" : "h-[60px]"
          }  !p-1 rounded-none !shadow-none !outline-none !border-0 flex justify-center items-center bg-transparent`}
        >
          <img
            src={hamClick ? SmallLogo : Logo}
            alt="Logo"
            className="h-full object-contain"
          />
        </Card>
        <Card
          className={`h-[calc(100%_-_65px)] relative !bg-transparent !shadow-none !outline-none !border-none border-t-0 rounded-none flex flex-col gap-1 p-1 px-4 text-black/80 overflow-y-auto ${
            hamClick ? "items-center" : ""
          }`}
        >
          {navItems.map((section) => (
            <React.Fragment key={section.id}>
              {!hamClick && (
                <p className="text-[0.8rem] font-semibold font-roboto text-[#293B94] uppercase tracking-wide mb-1 mt-3">
                  {section.category}
                </p>
              )}
              {section.items.map((item) => (
                <React.Fragment key={item.id}>
                  {!item.subcategory ? (
                    <Card
                      isPressable
                      className={`!shadow-none !outline-none w-full !border-none hover:bg-[#2344d630] rounded-lg cursor-pointer flex items-center gap-3 transition duration-200 ease-in-out ${
                        hamClick ? "justify-center" : ""
                      } ${
                        !location.pathname.includes("setting") &&
                        location.pathname.includes(item.path)
                          ? "bg-[#2344d650]"
                          : ""
                      }`}
                      title={hamClick ? item.label : ""}
                    >
                      <Link
                        to={item.path}
                        className={`w-full flex items-center ${
                          hamClick
                            ? "p-1.5 justify-center"
                            : "p-1.5 px-3 justify-start"
                        }`}
                      >
                        <div
                          className={`flex items-center gap-3 w-full text-sm !font-normal font-roboto text-gray-800 ${
                            hamClick ? "justify-center" : "justify-start"
                          } ${
                            location.pathname === item.path
                              ? "text-[#293B94]"
                              : ""
                          }`}
                        >
                          {location.pathname === item.path
                            ? item.activeIcon
                            : item.icon}
                          {!hamClick && <span>{item.label}</span>}
                        </div>
                      </Link>
                    </Card>
                  ) : (
                    <div key={item.id}>
                      <Card
                        isPressable
                        className={`!shadow-none !outline-none w-full !border-none hover:bg-[#2344d630] rounded-lg cursor-pointer flex items-center gap-3 transition duration-200 ease-in-out ${
                          hamClick ? "justify-center" : ""
                        } ${
                          !location.pathname.includes("setting") &&
                          location.pathname.includes(item.path)
                            ? "bg-[#2344d650]"
                            : ""
                        }`}
                        onClick={() => handleCardClick(item.id)}
                        title={hamClick ? item.label : ""}
                      >
                        <div
                          className={`w-full flex items-center ${
                            hamClick
                              ? "p-1.5 justify-center"
                              : "p-1.5 px-3 justify-start"
                          }`}
                        >
                          <div
                            className={`flex items-center gap-3 w-full text-sm !font-normal font-roboto text-gray-800 ${
                              hamClick ? "justify-center" : "justify-start"
                            }`}
                          >
                            {!location.pathname.includes("setting") &&
                            location.pathname.includes(item.path)
                              ? item.activeIcon
                              : item.icon}
                            {!hamClick && <span>{item.label}</span>}
                            {!hamClick && (
                              <FaAngleDown
                                className={`right-3 duration-200 absolute ${
                                  expandedCard === item.id ? "rotate-180" : ""
                                }`}
                              />
                            )}
                          </div>
                        </div>
                      </Card>
                      <div
                        className={`transition-max-height duration-300 ease-in-out overflow-hidden ${
                          expandedCard === item.id ? "max-h-96" : "max-h-0"
                        }`}
                      >
                        <div className="pl-3.5">
                          {item.subcategory.map((e) => (
                            <Card
                              key={e.path}
                              isPressable
                              className={`!shadow-none !outline-none w-full mt-[1px] !border-none hover:bg-[#2344d630] rounded-lg cursor-pointer flex items-center gap-3 transition duration-200 ease-in-out ${
                                hamClick ? "justify-center pr-1.5" : ""
                              } ${
                                location.pathname.includes(e.path)
                                  ? "bg-[#2344d650]"
                                  : ""
                              }`}
                              title={hamClick ? e.label : ""}
                            >
                              <Link
                                to={e.path}
                                className={`w-full flex items-center ${
                                  hamClick
                                    ? "p-1.5 justify-center"
                                    : "p-1.5 px-3 justify-start"
                                }`}
                              >
                                <div
                                  className={`flex items-center gap-3 w-full text-sm !font-normal font-roboto text-gray-800 ${
                                    hamClick
                                      ? "justify-center"
                                      : "justify-start"
                                  }`}
                                >
                                  {location.pathname === e.path
                                    ? e.activeIcon
                                    : e.icon}
                                  {!hamClick && <span>{e.label}</span>}
                                </div>
                              </Link>
                            </Card>
                          ))}
                        </div>
                      </div>
                    </div>
                  )}
                </React.Fragment>
              ))}
            </React.Fragment>
          ))}
          <div className="absolute bottom-2 text-gray-700 text-xs">
            Developed by Qpixel
          </div>
        </Card>
      </div>
    </div>
  );
};

export default SideNav;
